// extracted by css-extract-rspack-plugin
export default {"uploadVideo":"uploadVideo-2OqaS","thumbnail":"thumbnail-HzVDF"};